import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { getConfig } from '../config';
import { useContent } from '../contexts/ContentContext';
import { ImageMetadata, PublicFacet } from '../services/api';
import { facetSearchUrl, fetchRelatedThumbnails, relatedFacets } from '../services/discovery';

function FacetLink({ group, slug, label, imageId }: PublicFacet & { group: string; imageId: number }) {
    const [images, setImages] = useState<ImageMetadata[]>([]);
    useEffect(() => {
        let active = true;
        fetchRelatedThumbnails(group, slug).then(items => {
            if (active) setImages(items.filter(item => item.id !== imageId).slice(0, 3));
        }).catch(() => {});
        return () => { active = false; };
    }, [group, slug, imageId]);
    return <a className="lab-button lab-related-link inline-flex items-center gap-1" href={facetSearchUrl(group, slug)}>
        <span>{label}</span>
        {images.length > 0 && <span className="lab-related-thumbnails" aria-hidden="true">{images.map(image => <img key={image.id}
            src={new URL(image.thumb, new URL(getConfig().apiBaseUrl).origin).href} alt="" loading="lazy"
            onError={() => setImages(items => items.filter(item => item.id !== image.id))} />)}</span>}
        <ArrowRight size={16} aria-hidden="true" className="shrink-0" />
    </a>;
}

export default function RelatedImageLinks({ facets, imageId }: { facets: Record<string, PublicFacet>; imageId: number }) {
    const { t } = useContent();
    const related = relatedFacets(facets);
    if (!related.length) return null;
    return <section className="lab-related mt-6 border-t pt-4"><h2 className="font-bold mb-3">{t('discovery.next')}</h2>
        <div className="flex flex-wrap gap-3">{related.map(facet => <FacetLink key={`${imageId}:${facet.group}:${facet.slug}`} {...facet} imageId={imageId} />)}</div>
    </section>;
}
